import { Component, OnInit, Injector } from '@angular/core';
import { ActivateAccountComponent } from '@mango/activate-account';

@Component({
    selector: 'cij-activate-account',
    templateUrl: './activate-account.component.html',
    styleUrls: ['./activate-account.component.css']
})
export class CIJActivateAccountComponent extends ActivateAccountComponent implements OnInit {

    randomNumber: number;
    backgroundPictureCount: number = 7;

    constructor(injector: Injector) { 
        super(injector);

        this.randomNumber = Math.floor(Math.random() * this.backgroundPictureCount) + 1
    }
    

    getRandomBackground(): string {
        return `assets/login-photos/${this.randomNumber}.jpg`;
    }

}
